import {defineComponent, ref} from "vue"
import {useSharedStore} from "@/stores/useSharedStore";

export default defineComponent({
    setup() {

        const store = useSharedStore();

        const version = ref(store.version ?? localStorage.getItem('version') ?? 'Unknown version')
        const buildTime = ref(store.buildTime ?? localStorage.getItem('buildTime') ?? 'Unknown build time')
        const privacyStatementName = ref(store.privacyStatementName ?? localStorage.getItem('privacyStatementName') ?? '')
        const privacyStatementUrl = ref(store.privacyStatementUrl ?? localStorage.getItem('privacyStatementUrl') ?? '')

        return {
            version,
            buildTime,
            privacyStatementName,
            privacyStatementUrl
        }
    }
})